import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL + 'api/address';
//const API_BASE_URL = 'http://localhost:8080/api/address'; // Adjust API URL if necessary

// Function to fetch address by address code
export const fetchAddressByCode = async (addressCode, userId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/address-code-userId/${addressCode}`, {
      headers: { 
        'Authorization': `Bearer ${token}`,
        'userId': userId
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching address by code:', error);
    throw error;
  }
};

// Function to fetch addresses by user ID
export const fetchAddressesByUserId = async (userId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user-id/${userId}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching addresses by user ID:', error);
    throw error;
  }
};

// Function to save an address
export const saveAddress = async (addressData) => {
  try {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
      throw new Error('Token is missing');
    }

    const response = await axios.post(API_BASE_URL, addressData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data; // Return the response from the API
  } catch (error) {
    console.error('Error saving address:', error);
    throw error;
  }
};

// Function to delete an address by addressId
export const deleteAddress = async (addressId, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/${addressId}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return response after deleting
  } catch (error) {
    console.error('Error deleting address:', error);
    throw error;
  }
};

// Function to update an address by addressId
export const updateAddress = async (addressData, token) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${addressData.addressId}`, addressData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the updated address data
  } catch (error) {
    console.error('Error updating address:', error);
    throw error;
  }
};